<script>
export const group = 'Full'
</script>

<script setup>
import DefaultDarioPancarte from '../default/DarioPancarte.vue'
import ToFullBottomRight from './transitions/energetic_frequencies/ToFullBottomRight.vue'
import { ref, nextTick } from 'vue'

defineProps({
  item: Object,
})

const transition = ref(null)

const startTransition = async () => {
  await nextTick()
  if (transition.value) {
    transition.value.start()
  }
}
</script>

<template>
  <ToFullBottomRight ref="transition" :manualStart="true">
    <DefaultDarioPancarte class="bg-q-cr-red-darker" :item="item" :fade="false" @loaded="startTransition" />
  </ToFullBottomRight>
</template>
